/**
 * Internal dependencies
 */
import { headReady } from './head-ready';

export function appendStyle( css: string ): void {
	headReady( () => {
		const style = document.createElement( 'style' );
		style.innerHTML = css;
		document.head.appendChild( style );
	} );
}
